import { useState, useEffect, useMemo } from "react"
import _ from "lodash"
import { useParams } from "react-router-dom"
import { useLocation } from "react-router-dom"

import { GTM_VIEW_FEATURE_DETAIL } from "constant"

import config from "config"
import { getFeatureDetail } from "utils/feature"
import { pushDataLayer } from "utils/googletagmanager/pushDataLayer"
import { sortFeatureByLocaleKey } from "utils/sortFeatureByLocaleKey"

import { useVenue } from "providers/venue"
import { useDeviceLocation } from "hooks"
import { useTranslation } from "providers/i18n"

export const useFeatureDetail = () => {
  const { dataLoaded, occupants, findFeatureById } = useVenue()
  const [feature, setFeature] = useState(null)
  const { placeId } = useParams()
  const { deviceLocation } = useDeviceLocation()
  const location = useLocation()
  const mobileBaseUrl = config("mobileBaseUrl")
  const {
    i18n: { language: chosenLanguage },
  } = useTranslation()

  const placeDetailMobileUrl = useMemo(
    () =>
      `${mobileBaseUrl}${location.pathname}?user-location=${
        _.get(deviceLocation, "id") || ""
      }`,
    [mobileBaseUrl, deviceLocation, location]
  )

  const relatedOccupants = useMemo(() => {
    if (!feature) {
      return []
    }

    const featureType = feature?.feature_type
    let otherOccupants = []

    switch (featureType) {
      case "section":
        otherOccupants = occupants.filter(
          (occupant) => occupant.properties?.section?.id === placeId
        )
        break
      default:
        break
    }

    const sortedOccupants = sortFeatureByLocaleKey(
      otherOccupants,
      "properties.name",
      chosenLanguage
    )

    return sortedOccupants.length > 0 ? sortedOccupants : []
  }, [feature, occupants, placeId, chosenLanguage])

  useEffect(() => {
    if (!dataLoaded) return

    const feature = findFeatureById(placeId)
    setFeature(feature)
  }, [dataLoaded, placeId, findFeatureById])
  const featureDetail = useMemo(
    () => getFeatureDetail(feature) || {},
    [feature]
  )
  useEffect(() => {
    try {
      if (feature) {
        const localCategoriesName = _.map(
          feature?.properties?.local_categories,
          (taxonomy) => _.get(taxonomy, "properties.name.en")
        ).join(",")
        pushDataLayer({
          event: GTM_VIEW_FEATURE_DETAIL,
          feature_id: _.get(feature, "id"),
          feature_type: _.get(feature, "feature_type"),
          feature_name: _.get(feature, "properties.name.en"),
          feature_category: _.get(feature, "properties.category"),
          local_categories: localCategoriesName,
        })
      }
    } catch (err) {
      console.log(err)
    }
  }, [feature])

  return {
    ...featureDetail,
    relatedOccupants,
    feature,
    dataLoaded,
    placeDetailMobileUrl,
  }
}
